import React from 'react';

interface EquipmentStateBadgeProps {
    status: any; //Should be EquipmentStateName but build fails , need to investigate
}

export const EquipmentStateBadge = (props: EquipmentStateBadgeProps) => {
    return (
        <div
            data-variant='Waiting'
            className='bg-brand-muted flex items-start justify-center gap-2 rounded-full px-2 py-1'>
            <div className='text-background-surface justify-start text-center text-sm font-semibold'>{props.status.replace(/_/g, ' ')}</div>
        </div>
    );
};
